import React, { useState } from "react";
import "./Servic.css"

function Servic() {
   
    return (

      <>
    <section className="container pt-3 mb-3">
  <h2 className="h3 block-title text-center">What we do<small>Whatever we do, we do with your end user in mind </small></h2>
  <div className="row pt-5 mt-30">
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-user fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">UX Prototyping</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-user-circle-o fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">Web &amp; UI Design</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-address-book fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">Front-End Development</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-car fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">Back-End Development</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-camera fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">Usability Testing</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
    <div className="col-lg-4 col-sm-6 mb-30 pb-5">
      <a className="card" href="#">
        <div className="box-shadow bg-white rounded-circle mx-auto text-center" style={{width: 90, height: 90, marginTop: '-45px'}}><i className="fa fa-image fa-3x head-icon" /></div>
        <div className="card-body text-center">
          <h3 className="card-title pt-1">SEO Optimization</h3>
          <p className="card-text text-sm">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p><span className="text-sm text-uppercase font-weight-bold">Learn More&nbsp;<i className="fe-icon-arrow-right" /></span>
        </div>
      </a>
    </div>
  </div>
</section>

    

    </>
    );
  }
  
  export default Servic;
  